import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { pluginRegistry } from '../config';
import type { Theme } from '../plugins/types';
import { applyTheme, currentTheme, observeTheme } from '../theme';

export function Layout({ children }: { children: ReactNode }) {
  const { logout, userLabel } = useAuth();
  const [theme, setTheme] = useState<Theme>(currentTheme());
  useEffect(() => observeTheme(setTheme), []);

  return (
    <div className="shell">
      <header className="topbar">
        <Link to="/" className="brand">
          Hawk Plugins
        </Link>
        <nav className="nav">
          {pluginRegistry
            .filter(p => p.kind === 'browser')
            .map(p => (
              <Link key={p.id} to={`/plugins/${p.id}`}>
                {p.title}
              </Link>
            ))}
        </nav>
        <div className="spacer" />
        <button
          type="button"
          className="ghost"
          onClick={() => applyTheme(theme === 'dark' ? 'light' : 'dark')}
          title="Toggle light/dark"
        >
          {theme === 'dark' ? 'Light' : 'Dark'}
        </button>
        {userLabel && <span className="user">{userLabel}</span>}
        <button type="button" className="ghost" onClick={() => void logout()}>
          Log out
        </button>
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
